/**
 * extractTable
 *
 * HTML 문자열 또는 HTMLDivElement로부터 특정 selector를 이용해
 * 정확히 1개의 HTMLTableElement를 추출하여 반환합니다.
 *
 * ✅ 사용 목적:
 * - 학생 답안 또는 문제 데이터를 HTML로 받을 때, 특정 테이블을 정확히 1개만 추출하여 채점/검증에 사용하기 위함.
 *
 * @param div - HTML 문자열 또는 HTMLDivElement
 * @param selector - 테이블을 찾기 위한 CSS 선택자 (예: 'table.answer-table')
 * @returns 찾은 HTMLTableElement (없으면 undefined)
 * @throws 테이블이 정확히 1개가 아닐 경우 에러 발생
 */
export function extractTable(
  div: HTMLDivElement | string,
  selector: string,
): HTMLTableElement | undefined {
  let doc: HTMLElement | Document;

  if (typeof div === "string") {
    // div가 문자열(HTML 문자열)로 들어온 경우:
    // DOMParser를 사용하여 문자열을 Document 객체로 파싱
    const parser = new DOMParser();
    doc = parser.parseFromString(div, "text/html");
  } else {
    // div가 이미 HTMLDivElement로 들어온 경우:
    // 해당 div 자체를 탐색 대상으로 사용
    doc = div;
  }

  // doc 내에서 selector로 지정된 요소를 모두 찾음
  // selector는 보통 특정 테이블을 가리킴 (예: '.answer-table')
  const tables = doc.querySelectorAll(`${selector}`);

  // 조건: 정확히 1개의 테이블이 존재해야 함
  // 이유: 다수의 테이블이 존재하면 어떤 테이블을 기준으로 채점해야 할지 모호해짐
  if (tables.length != 1)
    throw new Error("답안 유형의 테이블을 1개 작성해주세요.");

  // 찾은 요소를 HTMLTableElement로 단언하여 반환
  return tables[0] as HTMLTableElement;
}
